
import Vue from "vue";
import { AskCenAiPrompt } from "../models/AskCenAiPrompt";

export default Vue.extend({
  name: "FollowupChips",
  props: {
    chips: {
      type: Array as () => AskCenAiPrompt[],
      default: () => [],
    },
  },
});
